import Container from '~/core/ui/Container';

import { Link } from '@remix-run/react';
import configuration from '~/configuration';
import Heading from '~/core/ui/Heading';
import LogoMini from '~/core/ui/Logo/LogoMini';
import { FooterCopyright } from './FooterCopyright';
import NewsletterSignup from './NewsletterSignup';

function Footer() {
  return (
    <footer className={'py-8 lg:py-24 !pb-80'}>
      <Container>
        <div
          className={'flex flex-col gap-4 space-y-8 lg:flex-row lg:space-y-0'}
        >
          <div
            className={
              'flex w-full space-x-4 lg:w-4/12 lg:space-x-6 xl:w-3/12 xl:space-x-6 2xl:space-x-8'
            }
          >
            <div className={'flex flex-col space-y-4'}>
              <div>
                <LogoMini className="flex w-fit" />
              </div>

              <div>
                <p className={'text-sm text-gray-500 dark:text-gray-400'}>
                  {configuration.site.description}
                </p>
              </div>

              <div className={'flex text-xs text-gray-500 dark:text-gray-400'}>
                <FooterCopyright />
              </div>
            </div>
          </div>

          <div
            className={
              'flex flex-col space-y-8 lg:space-y-0 lg:space-x-6' +
              ' xl:space-x-16 2xl:space-x-20' +
              ' w-full lg:flex-row lg:justify-end'
            }
          >
            <div>
              <div className={'flex flex-col space-y-4'}>
                <Heading type={6} className="mt-2 mb-[0.65rem]">
                  About
                </Heading>

                <FooterSectionList>
                  <FooterLink>
                    <Link to={'/about'}>About Us</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/blog'}>Blog</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/contact'}>Contact Us</Link>
                  </FooterLink>
                </FooterSectionList>
              </div>
            </div>

            <div>
              <div className={'flex flex-col space-y-4'}>
                <Heading type={6} className="mt-2 mb-[0.65rem]">
                  Product
                </Heading>

                <FooterSectionList>
                  {/* <FooterLink>
                    <Link to={'/docs'}>Documentation</Link>
                  </FooterLink> */}

                  <FooterLink>
                    <Link to={'/bible-characters'}>Bible Characters</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/tools'}>Tools</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/features'}>Features</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/faq'}>FAQs</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/pricing'}>Pricing</Link>
                  </FooterLink>
                </FooterSectionList>
              </div>
            </div>

            <div>
              <div className={'flex flex-col space-y-4'}>
                <Heading type={6} className="mt-2 mb-[0.65rem]">
                  Legal
                </Heading>

                <FooterSectionList>
                  <FooterLink>
                    <Link to={'/terms'}>Terms of Service</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/privacy'}>Privacy Policy</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to={'/cookies'}>Cookie Policy</Link>
                  </FooterLink>
                </FooterSectionList>
              </div>
            </div>

            <NewsletterSignup />
          </div>
        </div>
      </Container>
    </footer>
  );
}

function FooterSectionList(props: React.PropsWithChildren) {
  return (
    <ul className={'flex flex-col space-y-4 text-gray-500 dark:text-gray-400'}>
      {props.children}
    </ul>
  );
}

function FooterLink(props: React.PropsWithChildren) {
  return (
    <li
      className={
        'text-sm [&>a]:transition-colors [&>a]:hover:text-gray-800' +
        ' dark:[&>a]:hover:text-white'
      }
    >
      {props.children}
    </li>
  );
}

export default Footer;
